module.exports = __webpack_public_path__ + "static/media/digital-marketings.e9ce56e0.png";